var map = {
	"./modules/authentication/authentication.modules": [
		"./src/app/modules/authentication/authentication.modules.ts",
		"modules-authentication-authentication-modules"
	],
	"./modules/carehome/carehome.module": [
		"./src/app/modules/carehome/carehome.module.ts",
		"default~modules-carehome-carehome-module~modules-carehomes-carehomes-module~modules-citizen-citizen-~1bde25f6",
		"default~modules-carehome-carehome-module~modules-citizen-citizen-module~modules-eventconfiguration-e~decbf25e",
		"common",
		"modules-carehome-carehome-module"
	],
	"./modules/carehomes/carehomes.module": [
		"./src/app/modules/carehomes/carehomes.module.ts",
		"default~modules-carehome-carehome-module~modules-carehomes-carehomes-module~modules-citizen-citizen-~1bde25f6",
		"default~modules-carehomes-carehomes-module~modules-citizen-citizen-module~modules-reports-reports-module",
		"common",
		"modules-carehomes-carehomes-module"
	],
	"./modules/citizen/citizen.module": [
		"./src/app/modules/citizen/citizen.module.ts",
		"default~modules-carehome-carehome-module~modules-carehomes-carehomes-module~modules-citizen-citizen-~1bde25f6",
		"default~modules-carehome-carehome-module~modules-citizen-citizen-module~modules-eventconfiguration-e~decbf25e",
		"default~modules-carehomes-carehomes-module~modules-citizen-citizen-module~modules-reports-reports-module",
		"default~modules-citizen-citizen-module~modules-reports-reports-module"
	],
	"./modules/devices/devices.module": [
		"./src/app/modules/devices/devices.module.ts",
		"default~modules-devices-devices-module~modules-reports-reports-module",
		"modules-devices-devices-module"
	],
	"./modules/diaper/diaper.module": [
		"./src/app/modules/diaper/diaper.module.ts",
		"modules-diaper-diaper-module"
	],
	"./modules/event-generating/event-generating.module": [
		"./src/app/modules/event-generating/event-generating.module.ts",
		"default~modules-carehome-carehome-module~modules-carehomes-carehomes-module~modules-citizen-citizen-~1bde25f6",
		"modules-event-generating-event-generating-module"
	],
	"./modules/eventconfiguration/event-configuration.module": [
		"./src/app/modules/eventconfiguration/event-configuration.module.ts",
		"default~modules-carehome-carehome-module~modules-carehomes-carehomes-module~modules-citizen-citizen-~1bde25f6",
		"default~modules-carehome-carehome-module~modules-citizen-citizen-module~modules-eventconfiguration-e~decbf25e"
	],
	"./modules/reports/reports.module": [
		"./src/app/modules/reports/reports.module.ts",
		"default~modules-carehome-carehome-module~modules-carehomes-carehomes-module~modules-citizen-citizen-~1bde25f6",
		"default~modules-carehome-carehome-module~modules-citizen-citizen-module~modules-eventconfiguration-e~decbf25e",
		"default~modules-carehomes-carehomes-module~modules-citizen-citizen-module~modules-reports-reports-module",
		"default~modules-citizen-citizen-module~modules-reports-reports-module",
		"default~modules-devices-devices-module~modules-reports-reports-module",
		"common",
		"modules-reports-reports-module"
	],
	"./modules/settings/settings.module": [
		"./src/app/modules/settings/settings.module.ts",
		"modules-settings-settings-module"
	],
	"./modules/statistics/statistics.module": [
		"./src/app/modules/statistics/statistics.module.ts",
		"modules-statistics-statistics-module"
	],
	"./modules/statusoverview/status-overview.module": [
		"./src/app/modules/statusoverview/status-overview.module.ts",
		"common",
		"modules-statusoverview-status-overview-module"
	],
	"./modules/user/user.module": [
		"./src/app/modules/user/user.module.ts",
		"common",
		"modules-user-user-module"
	],
	"./modules/usermanagement/user-management.module": [
		"./src/app/modules/usermanagement/user-management.module.ts",
		"common",
		"modules-usermanagement-user-management-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;